import { Button, Card, Form } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Common/Header";
import BuyerInquiryForm from "./BuyerInquiryForm";

const AddBuyerInquiry = () => {
  // States
  const [styles, setStyles] = useState([]);
  const [users, setUsers] = useState([]);
  const [buyingOffice, setBuyingOffice] = useState([]);
  const [buyer, setBuyer] = useState([]);
  const [garmentCategoryList, setGarmentCategoryList] = useState([]);
  const [garmentTypeList, setGarmentTypeList] = useState([]);
  const [garmentForList, setGarmentForList] = useState([]);
  const [brand, setBrand] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Antd
  const [form] = Form.useForm();

  // Others
  const navigate = useNavigate();

  const discartForm = () => {
    navigate("/merchandising/buyer-inquiry");
  };

  const addBuyerInquiry = () => {
    console.log("addBuyerInquiry");
    const formValues = form.getFieldsValue();
    console.log("formValues", formValues);

    form.submit();
  };

  return (
    <>
      <div className="sticky-form-header">
        <Card style={{ width: "100%" }}>
          <Header
            disableAffix
            title="Add Buyer Inquiry"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={addBuyerInquiry} loading={isLoading}>
                Add Buyer Inquiry
              </Button>,
            ]}
          />
        </Card>
      </div>

      <div className="form-content-body">
        <BuyerInquiryForm
        form={form}
        users={users}
        setUsers={setUsers}
        styles={styles}
        setStyles={setStyles}
        buyingOffice={buyingOffice}
        setBuyingOffice={setBuyingOffice}
        buyer={buyer}
        setBuyer={setBuyer}
        garmentCategoryList={garmentCategoryList}
        setGarmentCategoryList={setGarmentCategoryList}
        garmentTypeList={garmentTypeList}
        setGarmentTypeList={setGarmentTypeList}
        garmentForList={garmentForList}
        setGarmentForList={setGarmentForList}
        brand={brand}
        setBrand={setBrand}
        countryList={countryList}
        setCountryList={setCountryList}
        documents={documents}
        setDocuments={setDocuments}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      </div>
    </>
  );
};

export default AddBuyerInquiry;
